import { UnshadowedElement, html } from "../lib/unshadowed.js";

/** Status message for submissions */
export class SubmitStatus extends UnshadowedElement {
    static elementName() { return "submit-status" }

    static properties = {
        id: { type: String },
        text: { type: String },
        error: { type: Boolean },
        info: { type: Boolean },
    }

    /**
     * Search the whole page for a <submit-status> and set the text
     * @param {String} id SubmitStatus element must have an id matching this
     * @param {String} text Message text
     * @param {Boolean} error True to show an error status
     * @param {Boolean} info True to show an info status
     */
    static Set(id, text, error, info) {
        const element = document.getElementsByTagName("submit-status").namedItem(id);
        if (element) {
            element.text = text;
            element.error = error;
            element.info = info;
        }
    }

    /**
     * Search the whole page for a <submit-status> and hide it
     * @param {any} id SubmitStatus element must have an id matching this
     */
    static Hide(id) {
        const element = document.getElementsByTagName("submit-status").namedItem(id);
        if (element) {
            element.text = "";
        }
    }

    render() {
        if (!this.text) return null;
        if (this.error) {
            return html`<div id="status" class="alert alert-danger text-wrap">${this.text}</div>`;
        } else if (this.info) {
            return html`<div id="status" class="alert alert-info text-wrap">${this.text}</div>`;
        } else {
            return html`<div id="status" class="alert alert-success alert-success-with-checkmark text-wrap">${this.text}</div>`;
        }
    }
}
